<template>
  <div class="t-calc__holder">
    <div class="t-calc__block t-calc__block_trio">
      <div class="t-calc__description t-calc__description_important">
        {{ title }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "OQPanel",
  props: ["title"],
};
</script>

<style scoped lang="scss"></style>
